module.exports = __webpack_public_path__ + "img/application-form.cdf8847e.jpg";